export default "__VITE_ASSET__Cmb9$fJ8__"